export default __webpack_public_path__ + "static/media/platinum-card.b491820d.svg";